import { FormikErrors } from "formik";
import { isEqual } from "lodash";
import { LimitType } from "model/schema/globalTypes";
import React from "react";
import NotificationSettings from "./NotificationSettings";
import { ServiceProductCreatable } from "./types";

interface NotificationSectionProps {
  errors: FormikErrors<ServiceProductCreatable>;
  values: Partial<ServiceProductCreatable>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate?: boolean
  ) => void;
  limitType?: LimitType;
}

const NotificationSection: React.FC<NotificationSectionProps> = ({
  errors,
  values,
  setFieldValue,
  limitType
}) => (
  <NotificationSettings
    errors={
      Array.isArray(errors.notificationTriggers)
        ? (errors.notificationTriggers as {
            email?: string;
            thresholds?: string[];
          }[])
        : undefined
    }
    onEmailChange={(email, idx) => {
      setFieldValue(`notificationTriggers.${idx}.email`, email);
    }}
    onThresholdChange={(payload, idx) => {
      const currentThresholds = values.notificationTriggers?.[idx]?.thresholds;
      const newThresholds = payload.value;
      if (isEqual(currentThresholds, newThresholds)) return;
      setFieldValue(`notificationTriggers.${idx}.thresholds`, newThresholds);
    }}
    notificationTriggers={values.notificationTriggers ?? []}
    onAddRow={() => {
      setFieldValue("notificationTriggers", [
        ...(values.notificationTriggers ?? []),
        { email: "", thresholds: [] }
      ]);
    }}
    onDeleteRow={idx => {
      setFieldValue(
        "notificationTriggers",
        (values.notificationTriggers ?? []).filter((_, i: number) => i !== idx)
      );
    }}
    limitType={limitType}
  />
);

export default NotificationSection;
